export const cardItemDetailsContainer = {
  width: "100vw",
  //   height: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};
